import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import {
  fetchSupplierInvoiceDetail,
  fetchSupplierInvoices,
} from '@/renderer/services/inventorySupplierInvoiceService';
import type { InventorySupplierInvoiceFilterParams } from '@/renderer/types/inventory';

export function useInventorySupplierInvoices(
  params: InventorySupplierInvoiceFilterParams,
) {
  return useQuery({
    queryKey: queryKeys.inventory.supplierInvoicesList(params),
    queryFn: async () => {
      const result = await fetchSupplierInvoices(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch supplier invoices');
      }
      return result.data;
    },
    enabled: !!params.companyId && !!params.outletId,
    placeholderData: keepPreviousData,
  });
}

export function useInventorySupplierInvoiceDetail(
  companyId: number | null,
  invoiceId: string | null,
) {
  return useQuery({
    queryKey: queryKeys.inventory.supplierInvoiceDetail(
      companyId ?? 0,
      invoiceId ?? '',
    ),
    queryFn: async () => {
      const result = await fetchSupplierInvoiceDetail(companyId!, invoiceId!);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch invoice detail');
      }
      return result.data;
    },
    enabled: !!companyId && !!invoiceId,
  });
}
